import React from 'react';

const WhatsAppWidget = () => {
  const whatsappNumber = "918796118101";
  const message = encodeURIComponent("Hello! I would like to talk to an expert about a web/mobile development project.");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="fixed bottom-20 right-5 z-40 flex items-center">

      {/* Floating Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        className="relative w-11 h-11 bg-emerald-500 hover:bg-emerald-600 rounded-full flex items-center justify-center shadow-xl shadow-emerald-500/30 hover:scale-110 transition-all duration-300 group focus:outline-none"
        aria-label="Talk to Expert (+91 8796 118 101) on WhatsApp"
      >
        {/* Pulse Effect */}
        <span className="absolute inset-0 rounded-full bg-emerald-400 opacity-75 animate-ping" />

        {/* WhatsApp Icon */}
        <svg
          className="w-5 h-5 fill-white relative z-10"
          viewBox="0 0 24 24"
        >
          <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984 0 1.763.459 3.486 1.332 5.003l-1.416 5.17 5.292-1.388c1.464.798 3.117 1.217 4.779 1.218h.004c5.506 0 9.989-4.478 9.99-9.984 0-2.669-1.037-5.176-2.922-7.062a9.925 9.925 0 0 0-7.069-2.941zm5.952 14.286c-.251.706-1.462 1.348-2.016 1.408-.507.055-1.156.079-1.857-.145-.436-.14-1.002-.324-1.748-.646-3.136-1.353-5.184-4.529-5.342-4.739-.158-.211-1.282-1.706-1.282-3.255 0-1.549.805-2.311 1.09-2.622.285-.311.623-.389.83-.389.208 0 .416.002.597.01.192.008.452-.073.708.541.258.622.88 2.148.957 2.304.077.156.129.338.026.545-.104.208-.156.338-.311.519-.156.182-.327.406-.468.545-.156.156-.319.325-.137.636.182.311.808 1.333 1.734 2.158 1.19 1.06 2.193 1.388 2.504 1.544.311.156.494.13.676-.078.182-.208.778-.908.986-1.22.208-.311.416-.26.701-.156.285.104 1.815.856 2.126 1.012.311.156.519.234.597.364.077.13.077.753-.174 1.459z" />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppWidget;
